/** Canonical Brazilian plate key: uppercase alphanumeric only (ABC1D23). */
export function normalizePlate(value: string): string {
  return String(value || '')
    .replace(/[^a-zA-Z0-9]/g, '')
    .toUpperCase();
}
